// Imports: local files.
import {
  GET_ABOUT_START,
  GET_ABOUT_SUCCESS,
  GET_ABOUT_FAILED,
  GET_ABOUT_RESET,
  GET_ONE_ABOUT_START,
  GET_ONE_ABOUT_SUCCESS,
  GET_ONE_ABOUT_FAILED,
  GET_ONE_ABOUT_RESET,
  CREATE_ABOUT_START,
  CREATE_ABOUT_SUCCESS,
  CREATE_ABOUT_FAILED,
  CREATE_ABOUT_RESET,
  UPDATE_ABOUT_START,
  UPDATE_ABOUT_SUCCESS,
  UPDATE_ABOUT_FAILED,
  UPDATE_ABOUT_RESET,
} from '../actions';

const initialLoadingState = {
  loading: false,
  success: false,
  data: null,
  error: false,
  errorMessage: null,
};
const initialState = {
  getAll: initialLoadingState,
  getOne: initialLoadingState,
  create: initialLoadingState,
  updateOne: initialLoadingState,
};

const productsReducer = (state = initialState, action) => {
  switch (action.type) {
    /**
     * =======================================================================
     * Get About
     * =======================================================================
     */
    case GET_ABOUT_START:
      return { ...state, getAll: { ...action.payload } };
    case GET_ABOUT_SUCCESS:
      return { ...state, getAll: { ...action.payload } };
    case GET_ABOUT_FAILED:
      return { ...state, getAll: { ...action.payload } };
    case GET_ABOUT_RESET:
      return { ...state, getAll: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Get One About
     * =======================================================================
     */
    case GET_ONE_ABOUT_START:
      return { ...state, getOne: { ...action.payload } };
    case GET_ONE_ABOUT_SUCCESS:
      return { ...state, getOne: { ...action.payload } };
    case GET_ONE_ABOUT_FAILED:
      return { ...state, getOne: { ...action.payload } };
    case GET_ONE_ABOUT_RESET:
      return { ...state, getOne: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Create About
     * =======================================================================
     */
    case CREATE_ABOUT_START:
      return { ...state, create: { ...action.payload } };
    case CREATE_ABOUT_SUCCESS:
      return { ...state, create: { ...action.payload } };
    case CREATE_ABOUT_FAILED:
      return { ...state, create: { ...action.payload } };
    case CREATE_ABOUT_RESET:
      return { ...state, create: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Update About
     * =======================================================================
     */
    case UPDATE_ABOUT_START:
      return { ...state, updateOne: { ...action.payload } };
    case UPDATE_ABOUT_SUCCESS:
      return { ...state, updateOne: { ...action.payload } };
    case UPDATE_ABOUT_FAILED:
      return { ...state, updateOne: { ...action.payload } };
    case UPDATE_ABOUT_RESET:
      return { ...state, updateOne: { ...initialLoadingState } };

    default:
      return state;
  }
};

export default productsReducer;
